import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GetLocalChurchService } from './context/get-local-church.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [GetLocalChurchService],
})
export class LocalChurchModule {}
